// tslint:disable
/**
 * GetInfo
 * Get info api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { CourseLectureProgress } from './course-lecture-progress';
import { CourseListener } from './course-listener';
import { CoursePracticeProgress } from './course-practice-progress';
import { CourseTestProgress } from './course-test-progress';

/**
 * 
 * @export
 * @interface CourseProgress
 */
export interface CourseProgress {
    /**
     * 
     * @type {string}
     * @memberof CourseProgress
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CourseProgress
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CourseProgress
     */
    listenerId: string;
    /**
     * 
     * @type {CourseListener}
     * @memberof CourseProgress
     */
    listener: CourseListener;
    /**
     * 
     * @type {Date}
     * @memberof CourseProgress
     */
    passedAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CourseProgress
     */
    success?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CourseProgress
     */
    status: CourseProgressStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CourseProgress
     */
    learningCompleted?: boolean;
    /**
     * 
     * @type {Array<CourseLectureProgress>}
     * @memberof CourseProgress
     */
    lectures?: Array<CourseLectureProgress>;
    /**
     * 
     * @type {CourseTestProgress}
     * @memberof CourseProgress
     */
    test?: CourseTestProgress;
    /**
     * 
     * @type {CoursePracticeProgress}
     * @memberof CourseProgress
     */
    practice?: CoursePracticeProgress;
}

/**
    * @export
    * @enum {string}
    */
export enum CourseProgressStatusEnum {
    Learning = 'learning',
    Success = 'success',
    NotSuccess = 'not_success'
}



